/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/custom_domain_limits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdCustomDomainLimits } from "./constants";
import type { GetLandingPagesCustomDomainLimitsResult } from "./types";

export const getLandingPagesCustomDomainLimits = reactQueryFetcherAdapter(
  engagementLandingPagesAppGroupIdCustomDomainLimits,
  (signal: AbortSignal, appGroupId: string): Promise<GetLandingPagesCustomDomainLimitsResult> => {
    return fetch(`/engagement/landing_pages/${appGroupId}/custom_domain_limits`, "GET", {}, { signal });
  }
);
